import TransactionsWeb from './TransactionsWeb';

export default TransactionsWeb;
